import { render, staticRenderFns } from "./PlanDay.vue?vue&type=template&id=54b21415&"
import script from "./PlanDay.vue?vue&type=script&lang=js&"
export * from "./PlanDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports